const MEETING_TYPE_LABELS: Record<string, string> = {
  Day1: 'Day 1',
  Day2: 'Day 2',
  Day3: 'Day 3',
  Day4: 'Day X（4回目以降）',
  DayX: 'Day X（4回目以降）',
  ProgressMTG: '進捗会議',
  PreMTG: '事前MTG',
  PostMTG: '事後MTG',
};

export function formatMeetingType(value?: string | null): string {
  if (!value) return '';
  return MEETING_TYPE_LABELS[value] ?? value;
}

export function formatDay1Variant(value?: string | null): string {
  if (value === 'first') return '初回';
  if (value === 'repeat') return '複数回目';
  return '';
}

export function formatSessionDay(value?: string | null, day1Variant?: string | null): string {
  const label = formatMeetingType(value);
  const variant = value === 'Day1' ? formatDay1Variant(day1Variant) : '';
  return variant ? `${label}（${variant}）` : label;
}

export function isNoSectionMeetingType(value?: string | null): boolean {
  return value === 'ProgressMTG' || value === 'PreMTG' || value === 'PostMTG';
}
